'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconWrapper = (0, _styledBase2.default)('div', {
	target: 'e1xp9zxm0',
	label: 'IconWrapper'
})('display:flex;align-items:center;justify-content:center;max-width:23px;width:max-content;cursor:pointer;height:100%;min-width:20px;svg.search-icon{fill:', function (_ref) {
	var theme = _ref.theme;
	return theme.colors.primaryColor;
}, ';transform:scale(1.25);}svg.cancel-icon{fill:', function (_ref2) {
	var theme = _ref2.theme;
	return theme.colors.borderColor || '#000';
}, ';}' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvSWNvbldyYXBwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRThCIiwiZmlsZSI6Ii4uLy4uL3NyYy9zdHlsZXMvSWNvbldyYXBwZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IEljb25XcmFwcGVyID0gc3R5bGVkLmRpdmBcblx0ZGlzcGxheTogZmxleDtcblx0YWxpZ24taXRlbXM6IGNlbnRlcjtcblx0anVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cdG1heC13aWR0aDogMjNweDtcblx0d2lkdGg6IG1heC1jb250ZW50O1xuXHRjdXJzb3I6IHBvaW50ZXI7XG5cdGhlaWdodDogMTAwJTtcblx0bWluLXdpZHRoOiAyMHB4O1xuXG5cdHN2Zy5zZWFyY2gtaWNvbiB7XG5cdFx0ZmlsbDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb2xvcnMucHJpbWFyeUNvbG9yfTtcblx0XHR0cmFuc2Zvcm06IHNjYWxlKDEuMjUpO1xuXHR9XG5cblx0c3ZnLmNhbmNlbC1pY29uIHtcblx0XHRmaWxsOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvciB8fCAnIzAwMCd9O1xuXHR9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBJY29uV3JhcHBlcjtcbiJdfQ== */'));

exports.default = IconWrapper;